import PropTypes from "prop-types";
import seatsImg from "../../../assets/images/seats.png";
import screen from "../../../assets/images/screen.svg";
import "./room.css";

Room.propTypes = {
  room: PropTypes.object,
  roomStatus: PropTypes.array,
  seats: PropTypes.array,
  setSeats: PropTypes.func,
  maxSeats: PropTypes.number,
  location: PropTypes.object,
};

export default function Room(props) {
  const { room, roomStatus, seats, setSeats, maxSeats, location } = props;
  const seatWidth = 35;

  const seatIsSelected = (chairData) => {
    return seats.find(
      (chair) =>
        chair.FilRelativa === chairData.FilRelativa &&
        chair.ColRelativa === chairData.ColRelativa
    );
  };

  const addOrRemoveChair = (chairData) => {
    const isAdded = seatIsSelected(chairData);
    if (isAdded) {
      const newseats = seats.filter(
        (seat) =>
          !(
            seat.Fila === isAdded.Fila &&
            seat.Columna === isAdded.Columna &&
            seat.FilRelativa === isAdded.FilRelativa &&
            seat.ColRelativa === isAdded.ColRelativa &&
            seat.Tarifa === isAdded.Tarifa
          )
      );
      setSeats(newseats);
    } else {
      if (seats.length < maxSeats) {
        setSeats([...seats, chairData]);
      } else {
        alert(
          `Solo puedes seleccionar ${maxSeats} asientos Si deseas seleccionar otro asiento, deselecciona uno de los asientos seleccionados`
        );
      }
    }
  };

  const blockedSeat = (column) => {
    return (
      <div className={`room-chair opacity`} key={column.index}>
        <div className={`room-chairname`}>
          {column.FilaRelativa}
          {column.ColumnaRelativa}
        </div>
        <div
          className="room-button"
          style={{ backgroundImage: `url(${seatsImg})` }}
        />
      </div>
    );
  };

  const renderRoom = () => {
    const {
      ColumnaRelativa,
      ColumnaTotal,
      FilaRelativa,
      FilaTotal,
      TipoSilla,
      TipoZona,
    } = room;

    let roomMatrix = [];

    FilaTotal.map((row, index) => {
      const isAdded = roomMatrix.filter((item) => item.row === row);
      const columnValue = {
        index,
        ColumnaRelativa: ColumnaRelativa[index],
        ColumnaTotal: ColumnaTotal[index],
        FilaRelativa: FilaRelativa[index],
        FilaTotal: row,
        TipoSilla: TipoSilla[index],
        TipoZona: TipoZona[index],
      };
      if (isAdded.length) {
        isAdded[0].columns.push(columnValue);
      } else {
        roomMatrix.push({
          row,
          columns: [columnValue],
        });
      }
      return null;
    });

    let minWidth = 0;

    const response = roomMatrix.map((row, index) => {
      const width = seatWidth * row.columns.length;
      minWidth = width > minWidth ? width : minWidth;
      let listStatus = roomStatus.filter(
        (item) => item.filRel === row.columns[0].FilaRelativa
      );
      listStatus = listStatus.length ? listStatus[0] : null;

      return (
        <div key={index} className="room-row" style={{ width, minWidth }}>
          {row.columns.map((column) => {
            if (column.TipoSilla === "pasillo") {
              return <div className="room-hall" key={column.index} />;
            }
            if (column.TipoZona.toUpperCase() !== location.zona.toUpperCase()) {
              return blockedSeat(column);
            }
            let status = "";
            let typeSeat = "";
            if (listStatus) {
              status = listStatus.DescripcionSilla.find(
                (item) =>
                  parseInt(item.Columna) === parseInt(column.ColumnaRelativa)
              );
              typeSeat = status.TipoSilla;
              status = status ? status.EstadoSilla : "";
            }

            if (typeSeat === "Discapacitado") {
              return blockedSeat(column);
            }

            const chairData = {
              Fila: column.FilaTotal,
              Columna: column.ColumnaTotal,
              FilRelativa: column.FilaRelativa,
              ColRelativa: column.ColumnaRelativa,
              Tarifa: location.codigo,
            };
            const seatselected = seatIsSelected(chairData);
            const selected = seatselected || status === "R" ? "selected" : "";

            const renderButton = status === "S" || status === "R";
            const chairBlocked = renderButton ? "" : "blocked";

            return (
              <div className="room-chair" key={column.index}>
                <div className={`room-chairname ${chairBlocked}`}>
                  {column.FilaRelativa}
                  {column.ColumnaRelativa}
                </div>
                {renderButton ? (
                  <button
                    type="button"
                    className={`room-button ${selected}`}
                    style={{ backgroundImage: `url(${seatsImg})` }}
                    onClick={() => addOrRemoveChair(chairData)}
                  />
                ) : (
                  <div
                    className={`room-button disabled`}
                    style={{ backgroundImage: `url(${seatsImg})` }}
                  />
                )}
              </div>
            );
          })}
        </div>
      );
    });

    return [
      <div style={{ width: minWidth }} key="screen">
        <div
          className="room-content-screen"
          style={{ backgroundImage: `url(${screen})` }}
        >
          <span>PANTALLA</span>
        </div>
      </div>,
      ...response,
    ];
  };

  return (
    <>
      <hr />
      <div className="showtimeDetail-label">
        Elige tus ubicaciones (hasta {maxSeats} asientos):
      </div>
      <div className="room">
        <div className="room-container scroll-bar">{renderRoom()}</div>
      </div>
      <div className="room-explanation">
        <div className="room-explanation-item">
          <div className="square available" /> Disponibles
        </div>
        <div className="room-explanation-item">
          <div className="square busy" /> Ocupadas
        </div>
        <div className="room-explanation-item">
          <div className="square selected" /> Seleccionadas
        </div>
      </div>
    </>
  );
}
